import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useI18n } from "../lib/i18n";

export default function PaymentCancel() {
  const { t } = useI18n();
  return (
    <div data-testid="payment-cancel-page" className="pt-32 pb-16 max-w-lg mx-auto px-6 text-center">
      <XCircle size={44} className="mx-auto text-[#7A2A2A]" strokeWidth={1.5} />
      <h1 className="mt-6 font-serif-display text-3xl text-[#143122]">{t("payment_cancelled_title")}</h1>
      <p className="mt-3 text-sm text-[#1A1F1C]/70">{t("payment_cancelled_sub")}</p>
      <Link to="/dashboard" className="mt-6 inline-block kav-btn-primary text-sm">
        {t("back_to_dashboard")}
      </Link>
    </div>
  );
}
